import React from 'react';
import { Result } from '../Interface/Response/Validator/Result';

const ResultContext = React.createContext<Result | null>(null);

export default ResultContext;
